import { ChevronDown } from 'lucide-react-native'
import React, { useState } from 'react'
import { Pressable, Text, View } from 'react-native'
import { useThemeValue } from '../../ThemeContext'
import { baseFont } from '../../utils/ui'

export function SelectField({
  value,
  options,
  onSelect,
  invalid = false,
}: {
  value: string
  options: string[]
  onSelect: (value: string) => void
  invalid?: boolean
}) {
  const { theme } = useThemeValue()
  const [open, setOpen] = useState(false)

  return (
    <View style={{ gap: 8 }}>
      <Pressable
        onPress={() => setOpen(current => !current)}
        style={{
          borderRadius: 16,
          borderWidth: 1,
          borderColor: invalid ? theme.colors.error : theme.colors.border,
          backgroundColor: theme.colors.surface,
          paddingHorizontal: 16,
          paddingVertical: 14,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Text style={{ ...baseFont('500'), color: theme.colors.text, fontSize: 16 }}>{value}</Text>
        <ChevronDown color={theme.colors.inactive} size={18} />
      </Pressable>
      {open ? (
        <View style={{ gap: 8 }}>
          {options.map(option => {
            const active = option === value

            return (
              <Pressable
                key={option}
                onPress={() => {
                  onSelect(option)
                  setOpen(false)
                }}
                style={{
                  borderRadius: 14,
                  borderWidth: 1,
                  borderColor: active ? theme.colors.primary : theme.colors.border,
                  backgroundColor: active ? `${theme.colors.primary}12` : theme.colors.card,
                  paddingHorizontal: 14,
                  paddingVertical: 12,
                }}
              >
                <Text
                  style={{ ...baseFont(active ? '700' : '500'), color: active ? theme.colors.primary : theme.colors.text, fontSize: 14 }}
                >
                  {option}
                </Text>
              </Pressable>
            )
          })}
        </View>
      ) : null}
    </View>
  )
}
